// import { notFound } from 'next/navigation';
import { API } from '../api';
import { axiosInstance } from '../axios';
import { CatalogFilterApplyParams } from '../postCatalogFilterApply/types';
import { ICatalogFilterCountData } from './types';

export const postCatalogFilterCount = async (body: CatalogFilterApplyParams) => {
  const result = await axiosInstance.post<ICatalogFilterCountData>(API.postCatalogFilterCount, body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return result.data?.data;
};
